import { BorderType } from 'common/types/styleTypes'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { Repeat04Icon } from '../../icons/repeat-04-icon'
import { ButtonSizeEnum, GhostIconButton } from '../../ui-lib/buttons'
import { BorderColorControl } from '../controls/border-color-control'
import { BorderRadiusControl } from '../controls/border-radius-control'
import { BorderStyleControl } from '../controls/border-style-control'
import { BorderTypeControl } from '../controls/border-type-control'
import { BorderWidthControl } from '../controls/border-width-control'

export interface BorderGroupProps {
  border: Partial<BorderType> | undefined
  defaultBorder?: Partial<BorderType> | undefined
  update: (value: Partial<BorderType>) => void
  isMobile?: boolean
  hideColorControl?: boolean
}

export const BorderGroup = ({
  border,
  defaultBorder,
  update,
  isMobile,
  hideColorControl,
}: BorderGroupProps) => {
  const onResetStyles = () => {
    if (defaultBorder) {
      update(defaultBorder)
    }
  }

  return (
    <>
      <GroupTitle
        isMobile={isMobile}
        afterChildren={
          defaultBorder && (
            <GhostIconButton
              size={ButtonSizeEnum.Small}
              onClick={onResetStyles}
              icon={<Repeat04Icon />}
            />
          )
        }
      >
        settings_styles.border_style.group_title
      </GroupTitle>
      <BorderTypeControl label="" border={border} update={update} />
      <BorderStyleControl border={border} update={update} />
      <BorderWidthControl border={border} update={update} />

      <BorderRadiusControl border={border} update={update} />
      {!hideColorControl && (
        <BorderColorControl border={border} update={update} />
      )}
    </>
  )
}
